// @flow
import Immutable from "seamless-immutable";
import { isString, isBlank } from "voca";

const pushToArrayProp = (obj: Immutable, path: string[] | string, values: any) => obj.updateIn((Array.isArray(path) ? path : [path]),
	(arr) => arr.concat(values));

const spliceArray = (arr: Immutable, index: number, count: number, ...items: any) => {
	arr = arr.asMutable();
	arr.splice(index, count, ...items);
	return arr;
};

const spliceArrayProp = (obj: Immutable, path: string[] | string, index: number, count: number = 1, ...items: any) =>
	obj.updateIn((Array.isArray(path) ? path : [path]),
		(arr: Immutable) => spliceArray(arr, index, count, ...items));

const filterArrayProp = (obj: Immutable, path: string[] | string, filterFn: Function) => obj.updateIn((Array.isArray(path) ? path : [path]),
	(arr: Immutable) => arr.asMutable().filter(filterFn));

const isEmpty = (obj: any) => (obj === null
    || obj === undefined
    || Array.isArray(obj) ? obj.length === 0
	: isString(obj) && isBlank(obj));

const withoutIn = (obj: Immutable, path: ?any[] | ?string, toRemove: string | string[], ...args: any[]) => {
	path = Array.isArray(path) ? path : isEmpty(path) ? null : [path];
	toRemove = Array.isArray(toRemove) ? toRemove.concat(args) : [toRemove].concat(args);

	const updater = (val) => Immutable.without(val, toRemove);

	return isEmpty(path)
		? Immutable.without(obj, toRemove)
	// $FlowFixMe - flow doesnt understand we already checked path isnt null
		: path.length > 1
			? obj.setIn(path, obj.updateIn(path, updater))
		// $FlowFixMe - flow is stupid... :(
			: obj.set(path[0], updater(obj[path[0]]));
};

export {
	pushToArrayProp,
	spliceArray,
	spliceArrayProp,
	filterArrayProp,
	withoutIn,
};
